export const companies = [
    {
        category: "company",
        name: "cellManager",
        img: "./images/cellManager.jpg",
        products: ["microStation"]
    },
    {
        category: "company",
        name: "microsoftImporter",
        img: "./images/microsoftOfficeImporter.jpg",
        products: ["microStation","autodesk","revit"]
    }
];

export const products = [
    {
        category: "products",
        name: "microStation",
        img: "./images/microStation.jpg",
    },
    {
        category: "products",
        name: "autodesk",
        img: "./images/autodesk.jpg",
    },
    {
        category: "products",
        name: "revit",
        img: "./images/revit.jpg",
    }
];

export const defaultSeats = [1,2,3,4,5];
